import { Clock, PlayCircle, Phone, Video } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fmtTime } from "@/lib/api";

const hoursLeft = (iso) => Math.max(0, Math.ceil((new Date(iso).getTime() - Date.now()) / 3600000));

export const PackageExpiryNotes = ({ me, onChanged }) => {
  const pkg = me?.active_package;
  const parked = me?.parked_packages || [];
  const hrs = me?.pkg_expiry_hours || 48;
  if (!pkg?.partially_used && !parked.length) return null;
  const activate = async (i) => { try { const { data } = await api.post(`/customer/package/activate/${i}`); toast.success(`${data.active_package?.staff_name} പാക്കേജ് സജീവമാക്കി`); onChanged?.(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <section data-testid="package-expiry-notes" className="space-y-2">
      {pkg?.partially_used && (
        <p data-testid="package-expiry-warning" className="rounded-2xl border-2 border-amber-400 bg-amber-50 text-amber-900 text-xs font-bold px-4 py-3 leading-snug inline-flex items-start gap-2 w-full">
          <Clock size={16} className="shrink-0 mt-0.5" />
          <span>⚠️ {hrs} മണിക്കൂറിനുള്ളിൽ ബാലൻസ് കോൾ വിളിച്ച് തീർക്കുക, ഇല്ലെങ്കിൽ തുക ക്യാൻസൽ ആകുന്നതാണ്.{pkg.expires_at && <> — <span data-testid="package-expiry-hours" className="font-num">{hoursLeft(pkg.expires_at)} മണിക്കൂർ</span> ബാക്കി ({pkg.staff_name} · {fmtTime(pkg.remaining_seconds)})</>}</span>
        </p>
      )}
      {parked.length > 0 && (
        <div data-testid="parked-packages" className="card rounded-2xl p-3 space-y-2">
          <p className="label-caps">കാത്തുവെച്ച ബാലൻസ് ടൈം ({parked.length})</p>
          {parked.map((p, i) => (
            <div key={`${p.staff_id}-${i}`} data-testid={`parked-package-${i}`} className="flex items-center gap-2 text-xs rounded-xl bg-[var(--bg)] border border-[var(--line)] px-3 py-2">
              <span className={`inline-flex items-center gap-1 rounded-full px-1.5 py-0.5 text-[10px] font-bold ${p.call_type === "video" ? "bg-fuchsia-500/15 text-fuchsia-600" : "bg-sky-500/15 text-sky-600"}`}>{p.call_type === "video" ? <Video size={11} /> : <Phone size={11} />}</span>
              <span className="font-bold truncate">{p.staff_name}</span>
              <span className="font-num text-[var(--accent-c)] font-bold">{fmtTime(p.remaining_seconds)}</span>
              {p.expires_at && <span data-testid={`parked-expiry-${i}`} className="text-[10px] text-amber-700 font-bold ml-auto whitespace-nowrap">⏳ {hoursLeft(p.expires_at)}h</span>}
              <button type="button" data-testid={`parked-activate-${i}`} onClick={() => activate(i)} className="btn-accent rounded-full h-7 px-2.5 text-[10px] font-bold inline-flex items-center gap-1"><PlayCircle size={12} /> സജീവമാക്കുക</button>
            </div>
          ))}
          <p className="text-[10px] text-[var(--muted-text)]">ഓരോ പാക്കേജും അവസാനം വിളിച്ചതിന് ശേഷം {hrs} മണിക്കൂറിനുള്ളിൽ തീർക്കുക — അല്ലെങ്കിൽ ബാക്കി സമയം സ്വയം ക്യാൻസൽ ആകും.</p>
        </div>
      )}
    </section>
  );
};
